import React, { useContext, useEffect, useState } from "react";
import PaymentCard from "./Payment";
import { MyContext } from "../../context/MyContext";

const Navbar = () => {
  const { showPayment, setShowPayment, navigate } = useContext(MyContext);

  const token = localStorage.getItem("token");

  useEffect(() => {}, []);
  const handleClick = () => {
    if (token) {
      setShowPayment(true);
    } else {
      setShowPayment(false);
      navigate("/login-user");
    }
  };

  return (
    <header className="bg-[#b570f6] text-black">
      {/* Reduced padding */}
      <nav className="container mx-auto flex flex-row sm:flex-row items-center justify-between px-4 sm:h-12 gap-10">
        <div className="text-left sm:text-left sm:flex-1 ">
          <p className="font-medium text-[12px] text-wrap sm:text-[16px] max-w-[500px]">
            Your Success Story Starts Here – Be a Part of Our MicroLife!
          </p>
        </div>

        {/* Button - Adjusts for Mobile & Desktop */}
        <div className="mt-0 sm:mt-0">
          <button
            onClick={handleClick}
            className="bg-[#a855f7] text-white text-[9px] sm:text-lg font-semibold py-1 px-3 sm:px-5 rounded-lg transition-transform   bg-gradient-to-br from-blue-600 via-purple-600 to-pink-700 hover:scale-105"
          >
            Join OurMicroLife
          </button>
        </div>
      </nav>
      {/* Payment Card */}
      {showPayment && <PaymentCard />}
    </header>
  );
};

export default Navbar;
